import React, { useContext as useContextCore } from 'react'

export type PasskeyAuthenticationProviderProps = {
  apiBaseUrl: string
  children: React.ReactNode
}

export type PasskeyAuthenticationContextType = {
  apiBaseUrl: string
}

const context = React.createContext<PasskeyAuthenticationContextType>({} as PasskeyAuthenticationContextType)
const CoreProvider = context.Provider

export const PasskeyAuthenticationProvider = ({ children, ...props }: PasskeyAuthenticationProviderProps) => {
  return <CoreProvider value={{ ...props }}>{children}</CoreProvider>
}

export const usePasskeyAuthenticationContext = () => useContextCore(context)
